import { createScreenStyles } from '../../theme/styles';
import { OPERATIONS_API_BASE } from '../../config/api';
import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, Dimensions, ScrollView, TouchableHighlight} from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons'; 

const screenWidth = Math.round(Dimensions.get('window').width);
const screenHeight = Math.round(Dimensions.get('window').height);


const preIndexType = ( {navigation} ) => {

  const [count, setCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [countComp, setCountComp] = useState("");
  const [countCompExit, setCountCompExit] = useState("");

  async function loadCounts() {
    const response = await fetch(
      //`${OPERATIONS_API_BASE}/checklistcomp/countDocs`
      `${OPERATIONS_API_BASE}/checklistcomp/countDocs/app/type/summary`
    );

    const data = await response.json();
    setCount(data);

    const responseEntrada = await fetch(
      `${OPERATIONS_API_BASE}/checklistcomp/countDocs`
    );

    const dataEntrada = await responseEntrada.json();
    setCountComp(dataEntrada);

    const responseExit = await fetch(
      `${OPERATIONS_API_BASE}/checklistcomp/count/docs/exit`
    );

    const dataExit = await responseExit.json();
    setCountCompExit(dataExit);




    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    loadCounts();
  }, []);

  return (
  
        <ScrollView style={styles.content}>
          

          <View style={styles.row}>

            <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('CompPreIndex', { type: 0 }) }}>
              <View style={styles.menuItem}>     
              {countComp.totalRecords0 > 0 &&   
                  <View style={styles.circle}><Text style={styles.textcircle}>{countComp.totalRecords0}</Text></View>
              }
                <FontAwesome name="arrow-circle-up" size={36} color="#00004C" /> 
                <Text style={styles.textMenu}>Entrada ({count.totalRecords0})</Text>
              </View>
            </TouchableHighlight>


            <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('CompPreIndex', { type: 1 }) }}>
              <View style={styles.menuItem}>      
              {countCompExit.totalRecords0 > 0 &&   
                  <View style={styles.circle}><Text style={styles.textcircle}>{countCompExit.totalRecords0}</Text></View>
              }
                <FontAwesome5 name="arrow-circle-down" size={36} color="#00004C" /> 
                <Text style={styles.textMenu}>Saída ({count.totalRecords1})</Text>
              </View>
            </TouchableHighlight>
  

          </View>



        </ScrollView>


    );
}

var styles = createScreenStyles({


  backImageHeader: {
    width: '100%'
  },

  content: {
    paddingHorizontal: 16
  },

  contentContainer: {
    height:'100%',
    backgroundColor: '#f3f3f3',

  },


  menuItem:{
    width: '100%',
    minHeight: 124, paddingVertical: 20,
    marginBottom:20,
    flex:1,
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius:10,
    shadowColor: "#000",
    shadowOffset: {
      width: 8,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 3.49,
    elevation: 5,
  },

  textMenu: {
    fontSize:16,
    paddingTop:10,
    color: '#003c84',
    textAlign:'center'
  },

  row:{
    marginTop:20,
  },

  circle: {
    width: 30,
    height: 30,
    backgroundColor:'#e32636',
    borderRadius:100,
    alignItems:'center',
    justifyContent:'center',
    position:'absolute',
    top:12,
    right:12
  },
  textcircle: {
    color:'#fff',
    fontWeight:'bold'
  }
});

export default preIndexType;